import React from 'react';

export interface Sign3IconProps {}

export const Sign3Icon: React.FC<Sign3IconProps> = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5985 5.20552C16.8076 5.22212 18.5851 7.02622 18.569 9.23529L18.5 18.5L15.5001 18.4778L15.5688 9.21304C15.5729 8.66077 15.1285 8.20975 14.5763 8.20565C14.3085 8.20367 14.0511 8.30916 13.8617 8.49852L9.87749 12.4825L13.5626 14.2425C13.7061 14.311 13.8073 14.443 13.8376 14.5967L13.8456 14.6553C13.8653 14.911 13.6891 15.1365 13.4434 15.1844L13.3855 15.1922L4.41699 15.8823L5.1071 6.91383C5.12082 6.7355 5.22875 6.57808 5.39015 6.501C5.62153 6.3905 5.89542 6.47359 6.02865 6.68554L6.05681 6.73671L7.77749 10.3395L11.7404 6.3772C12.4978 5.61978 13.5274 5.19779 14.5985 5.20552Z"
        fill="#192033"
      />
    </svg>
  );
};
